import { makeNetTerms } from '~/infra/translator';
import { assertUnreachable } from '~/infra/utils';
export var AmendmentDraftChangeType = /*#__PURE__*/ function(AmendmentDraftChangeType) {
    AmendmentDraftChangeType["ServiceCost"] = "ServiceCostChange";
    AmendmentDraftChangeType["NetTerms"] = "NetTermsChange";
    AmendmentDraftChangeType["ServiceName"] = "ServiceNameChange";
    AmendmentDraftChangeType["ServiceDescription"] = "ServiceDescriptionChange";
    AmendmentDraftChangeType["ServiceTermsUpdated"] = "ServiceTermsUpdatedChange";
    AmendmentDraftChangeType["ServiceTermsRemoved"] = "ServiceTermsRemovedChange";
    AmendmentDraftChangeType["ServiceBilledUpon"] = "ServiceBilledUponChange";
    AmendmentDraftChangeType["ServiceBundle"] = "ServiceBundleChange";
    AmendmentDraftChangeType["ServiceAdded"] = "ServiceAddedChange";
    AmendmentDraftChangeType["ServiceTerminated"] = "ServiceTerminatedChange";
    AmendmentDraftChangeType["ServiceCanceled"] = "ServiceCanceledChange";
    AmendmentDraftChangeType["ServiceIntegratedClass"] = "ServiceIntegratedClassChange";
    AmendmentDraftChangeType["ManualPayments"] = "ManualPaymentsChange";
    AmendmentDraftChangeType["CoverCreditCardFees"] = "CoverCreditCardFeesChange";
    AmendmentDraftChangeType["LegalTermsDocuments"] = "LegalTermsDocumentsChange";
    AmendmentDraftChangeType["AmendmentsApprovalMethod"] = "AmendmentsApprovalMethodChange";
    AmendmentDraftChangeType["InvoicesApprovalMethod"] = "InvoicesApprovalMethodChange";
    AmendmentDraftChangeType["CustomPageAdded"] = "CustomPageAddedChange";
    AmendmentDraftChangeType["CustomPageUpdated"] = "CustomPageUpdatedChange";
    return AmendmentDraftChangeType;
}({});
export function acceptAmendmentDraftChange(change, visitor) {
    switch(change.type){
        case "ServiceCostChange":
            var _visitor_visitServiceCost;
            return (_visitor_visitServiceCost = visitor.visitServiceCost) === null || _visitor_visitServiceCost === void 0 ? void 0 : _visitor_visitServiceCost.call(visitor, change.value);
        case "NetTermsChange":
            var _visitor_visitNetTerms;
            return (_visitor_visitNetTerms = visitor.visitNetTerms) === null || _visitor_visitNetTerms === void 0 ? void 0 : _visitor_visitNetTerms.call(visitor, change.value);
        case "ServiceNameChange":
            var _visitor_visitServiceName;
            return (_visitor_visitServiceName = visitor.visitServiceName) === null || _visitor_visitServiceName === void 0 ? void 0 : _visitor_visitServiceName.call(visitor, change.value);
        case "ServiceDescriptionChange":
            var _visitor_visitServiceDescription;
            return (_visitor_visitServiceDescription = visitor.visitServiceDescription) === null || _visitor_visitServiceDescription === void 0 ? void 0 : _visitor_visitServiceDescription.call(visitor, change.value);
        case "ServiceTermsUpdatedChange":
            var _visitor_visitServiceTermsUpdated;
            return (_visitor_visitServiceTermsUpdated = visitor.visitServiceTermsUpdated) === null || _visitor_visitServiceTermsUpdated === void 0 ? void 0 : _visitor_visitServiceTermsUpdated.call(visitor, change.value);
        case "ServiceTermsRemovedChange":
            var _visitor_visitServiceTermsRemoved;
            return (_visitor_visitServiceTermsRemoved = visitor.visitServiceTermsRemoved) === null || _visitor_visitServiceTermsRemoved === void 0 ? void 0 : _visitor_visitServiceTermsRemoved.call(visitor, change.value);
        case "ServiceBilledUponChange":
            var _visitor_visitServiceBilledUpon;
            return (_visitor_visitServiceBilledUpon = visitor.visitServiceBilledUpon) === null || _visitor_visitServiceBilledUpon === void 0 ? void 0 : _visitor_visitServiceBilledUpon.call(visitor, change.value);
        case "ServiceBundleChange":
            var _visitor_visitServiceBundle;
            return (_visitor_visitServiceBundle = visitor.visitServiceBundle) === null || _visitor_visitServiceBundle === void 0 ? void 0 : _visitor_visitServiceBundle.call(visitor, change.value);
        case "ServiceAddedChange":
            var _visitor_visitServiceAdded;
            return (_visitor_visitServiceAdded = visitor.visitServiceAdded) === null || _visitor_visitServiceAdded === void 0 ? void 0 : _visitor_visitServiceAdded.call(visitor, change.value);
        case "ServiceTerminatedChange":
            var _visitor_visitServiceTerminated;
            return (_visitor_visitServiceTerminated = visitor.visitServiceTerminated) === null || _visitor_visitServiceTerminated === void 0 ? void 0 : _visitor_visitServiceTerminated.call(visitor, change.value);
        case "ServiceCanceledChange":
            var _visitor_visitServiceCanceled;
            return (_visitor_visitServiceCanceled = visitor.visitServiceCanceled) === null || _visitor_visitServiceCanceled === void 0 ? void 0 : _visitor_visitServiceCanceled.call(visitor, change.value);
        case "ServiceIntegratedClassChange":
            var _visitor_visitServiceIntegratedClass;
            return (_visitor_visitServiceIntegratedClass = visitor.visitServiceIntegratedClass) === null || _visitor_visitServiceIntegratedClass === void 0 ? void 0 : _visitor_visitServiceIntegratedClass.call(visitor, change.value);
        case "ManualPaymentsChange":
            var _visitor_visitManualPayments;
            return (_visitor_visitManualPayments = visitor.visitManualPayments) === null || _visitor_visitManualPayments === void 0 ? void 0 : _visitor_visitManualPayments.call(visitor, change.value);
        case "CoverCreditCardFeesChange":
            var _visitor_visitCoverCreditCardFees;
            return (_visitor_visitCoverCreditCardFees = visitor.visitCoverCreditCardFees) === null || _visitor_visitCoverCreditCardFees === void 0 ? void 0 : _visitor_visitCoverCreditCardFees.call(visitor, change.value);
        case "LegalTermsDocumentsChange":
            var _visitor_visitLegalTermsDocuments;
            return (_visitor_visitLegalTermsDocuments = visitor.visitLegalTermsDocuments) === null || _visitor_visitLegalTermsDocuments === void 0 ? void 0 : _visitor_visitLegalTermsDocuments.call(visitor, change.value);
        case "AmendmentsApprovalMethodChange":
            var _visitor_visitAmendmentsApprovalMethod;
            return (_visitor_visitAmendmentsApprovalMethod = visitor.visitAmendmentsApprovalMethod) === null || _visitor_visitAmendmentsApprovalMethod === void 0 ? void 0 : _visitor_visitAmendmentsApprovalMethod.call(visitor, change.value);
        case "InvoicesApprovalMethodChange":
            var _visitor_visitInvoicesApprovalMethod;
            return (_visitor_visitInvoicesApprovalMethod = visitor.visitInvoicesApprovalMethod) === null || _visitor_visitInvoicesApprovalMethod === void 0 ? void 0 : _visitor_visitInvoicesApprovalMethod.call(visitor, change.value);
        case "CustomPageAddedChange":
            var _visitor_visitCustomPageAdded;
            return (_visitor_visitCustomPageAdded = visitor.visitCustomPageAdded) === null || _visitor_visitCustomPageAdded === void 0 ? void 0 : _visitor_visitCustomPageAdded.call(visitor, change.value);
        case "CustomPageUpdatedChange":
            var _visitor_visitCustomPageUpdated;
            return (_visitor_visitCustomPageUpdated = visitor.visitCustomPageUpdated) === null || _visitor_visitCustomPageUpdated === void 0 ? void 0 : _visitor_visitCustomPageUpdated.call(visitor, change.value);
        default:
            return assertUnreachable(change);
    }
}
export const makeServiceCostChange = (serviceId, cost)=>({
        type: "ServiceCostChange",
        value: {
            serviceId,
            cost
        }
    });
export const makeNetTermsChange = (netTerms)=>({
        type: "NetTermsChange",
        value: {
            netTerms: makeNetTerms(netTerms)
        }
    });
export const makeServiceNameChange = (serviceId, name)=>({
        type: "ServiceNameChange",
        value: {
            serviceId,
            name
        }
    });
export const makeServiceDescriptionChange = (serviceId, description)=>({
        type: "ServiceDescriptionChange",
        value: {
            serviceId,
            description
        }
    });
export const makeServiceTermsUpdatedChange = (serviceId, terms)=>({
        type: "ServiceTermsUpdatedChange",
        value: {
            serviceId,
            terms
        }
    });
export const makeServiceTermsRemovedChange = (serviceId)=>({
        type: "ServiceTermsRemovedChange",
        value: {
            serviceId
        }
    });
export const makeServiceBilledUponChange = (serviceId, billedUpon)=>({
        type: "ServiceBilledUponChange",
        value: {
            serviceId,
            billedUpon
        }
    });
export const makeServiceBundleChange = (serviceId, bundle)=>({
        type: "ServiceBundleChange",
        value: {
            serviceId,
            bundle
        }
    });
export const makeServiceAddedChange = (serviceId, service)=>({
        type: "ServiceAddedChange",
        value: {
            serviceId,
            service
        }
    });
export const makeServiceTerminatedChange = (serviceId)=>({
        type: "ServiceTerminatedChange",
        value: {
            serviceId
        }
    });
export const makeServiceCanceledChange = (serviceId)=>({
        type: "ServiceCanceledChange",
        value: {
            serviceId
        }
    });
export const makeServiceIntegratedClassChange = (serviceId, integratedClass)=>({
        type: "ServiceIntegratedClassChange",
        value: {
            serviceId,
            integratedClass
        }
    });
export const makeManualPaymentsChange = (allowManualPayments)=>({
        type: "ManualPaymentsChange",
        value: {
            allowManualPayments
        }
    });
export const makeCoverCreditCardFeesChange = (coverCreditCardFees)=>({
        type: "CoverCreditCardFeesChange",
        value: {
            coverCreditCardFees
        }
    });
export const makeLegalTermsDocumentsChange = (legalTermsDocuments)=>({
        type: "LegalTermsDocumentsChange",
        value: {
            legalTermsDocuments
        }
    });
export const makeAmendmentsApprovalMethodChange = (amendmentsApprovalMethod)=>({
        type: "AmendmentsApprovalMethodChange",
        value: {
            amendmentsApprovalMethod
        }
    });
export const makeInvoicesApprovalMethodChange = (invoicesApprovalMethod)=>({
        type: "InvoicesApprovalMethodChange",
        value: {
            invoicesApprovalMethod
        }
    });
export const makeCustomPageAddedChange = (page)=>({
        type: "CustomPageAddedChange",
        value: {
            page
        }
    });
export const makeCustomPageUpdatedChange = (page)=>({
        type: "CustomPageUpdatedChange",
        value: {
            page
        }
    });
